module.exports = __webpack_public_path__ + "static/media/01_registro_fondo_iconos.2955b1b6.png";